import React, { useState, useRef } from 'react';
import { colors } from 'globalStyle';
import { Ghost } from 'components/Buttons';
import { Title, Text } from 'components/Texts';
import { Box, styled } from '@material-ui/core';
import { isOverflown } from 'util/elementProperties';

export default function ProjectTextContent({
  contentName, text, isDesktop, noLimit,
}) {
  const textRef = useRef();
  const textRef2 = useRef();
  const [showFullText, setShowFullText] = useState(isDesktop);
  return (
    <>
      {isDesktop && (
        <Title color={colors.primary} mb={45} size={24} isCenter>
          {contentName}
        </Title>
      )}
      <Text size={isDesktop ? 15 : 13} isCenter={isDesktop}>
        <TextContainer
          component="p"
          ref={textRef}
          noLimit={noLimit}
          showFullText={showFullText}
        >
          <TextContainer
            component="p"
            ref={textRef2}
            noLimit={noLimit}
            showFullText={showFullText}
          >
            {text}
          </TextContainer>
        </TextContainer>
      </Text>
      {!isDesktop
        && !noLimit
        && (isOverflown(textRef?.current) || isOverflown(textRef2?.current))
        && (
          <Ghost
            mt={10}
            isCenter
            isSubmit
            size={14}
            underline
            fullWidth
            color={colors.primary}
            onClick={() => setShowFullText((curr) => !curr)}
          >
            {showFullText ? 'Ver menos' : 'Ver más'}
          </Ghost>
        )}
    </>
  );
}

const TextContainer = styled(Box)((props) => ({
  overflow: 'hidden',
  whiteSpace: 'pre-wrap',
  maxHeight: !props.noLimit && (props.showFullText ? 'initial' : '130px'),
}));
